var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style['gift-icon']},[_c('font-awesome-icon',{attrs:{"icon":"gift"}}),_c('div',{class:_vm.$style['notification']},[_c('div')])],1)}
var staticRenderFns = []

export { render, staticRenderFns }